module.exports = __webpack_public_path__ + "media/images/image_placeholder-f5702bd9223de3eed373ef726056be6e.jpg";